<template>
    <div>
        <div class="flex flex-row items-center justify-start gap-2 px-3 py-2 hover:bg-slate-100 w-full">
            <slot />
            <!-- Parent -->
            <router-link :class="{ 'font-medium': children.length > 0 }"
                :to="{ name: 'Search', query: { categories: allSlugs } }" class="block w-full whitespace-nowrap">{{ name
                }}
            </router-link>
            <div v-if="children.length > 0" @click="open = !open" :class="!open ? 'bg-theme1' : 'bg-slate-500'"
                class="p-1 ml-4 rounded-md text-white transition-all duration-500">
                <ChevronDown class="transition-all duration-500" :class="open ? 'rotate-180' : 'rotate-0'" :size="14" />
            </div>
        </div>
        <!-- Child menu -->
        <template v-if="children && children.length > 0">
            <div :class="open ? 'h-auto' : 'h-0'" class="overflow-hidden" v-for="child in children" :key="child.slug">
                <NavChildLoop class="pl-2" :children="child.children" :name="child.name" :slug="child.slug">
                    <div v-if="children.length > 0" class="shrink-0">
                        <CornerDownRight :size="14" />
                    </div>
                </NavChildLoop>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { CornerDownRight, ChevronDown } from 'lucide-vue-next'
import { ref } from 'vue'

const open = ref(false)

interface ListItem {
    name: string
    slug: string
    children: ListItem[]
}

const props = defineProps({
    name: String,
    slug: String,
    children: {
        type: Array as () => ListItem[],
        default: () => []
    }
})

const collectSlugs = (slug: string, children: ListItem[]): string[] => {
    let allSlugs = [slug]
    children.forEach((child) => {
        allSlugs.push(...collectSlugs(child.slug, child.children))
    })
    return allSlugs
}

const allSlugs = collectSlugs(props.slug || '', props.children).join('+')
</script>

<style scoped></style>
